import React from 'react'

import './page.scss'

const Page = ({ children, className = '' }) => (
  <section className={`page ${className}`}>{children}</section>
)

export default Page



// WEBPACK FOOTER //
// ./src/components/common/Page/Page.js